module.exports = __webpack_public_path__ + "img/Clackmannanshire.55af1a17.png";